import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { TRIGGER_KEYS } from '../MultiInputConstants';

const withSelectTriggersHOCGenerator = (Component, { inputDOMSelector }) => {
  function WithSelectTriggersHOC(props) {
    const { createdRef, validateOnSelect, inputValue } = props;

    useEffect(() => {
      const keyDownListener = (e) => {
        const key = TRIGGER_KEYS[e.keyCode];

        switch (key) {
          case 'enter':
          case 'space':
          case 'tab':
            if (inputValue) {
              e.preventDefault();
              validateOnSelect();
            }
            break;
          default:
            break;
        }
      };
      const inputBlurListener = () => {
        if (inputValue) {
          validateOnSelect();
        }
      };
      const domRef = createdRef.current;
      const input = domRef && domRef.querySelector(inputDOMSelector);

      if (domRef) {
        domRef.addEventListener('keydown', keyDownListener);
      }
      if (input) {
        input.addEventListener('blur', inputBlurListener);
      }

      return () => {
        if (domRef) {
          domRef.removeEventListener('keydown', keyDownListener);
        }
        if (input) {
          input.removeEventListener('blur', inputBlurListener);
        }
      };
    }, [inputValue]);

    return <Component {...props} />;
  }

  WithSelectTriggersHOC.propTypes = {
    createdRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
    validateOnSelect: PropTypes.func,
    inputValue: PropTypes.string,
  };

  return WithSelectTriggersHOC;
};

const withSelectTriggers =
  ({ inputDOMSelector }) =>
  (Component) =>
    withSelectTriggersHOCGenerator(Component, { inputDOMSelector });

export default withSelectTriggers;
